__turbopack_context__.v({
  "pdp-badge": "ScrollGallery-module-scss-module__gS2LcG__pdp-badge",
  "pdp-badge-low-stock": "ScrollGallery-module-scss-module__gS2LcG__pdp-badge-low-stock",
  "pdp-slider-main": "ScrollGallery-module-scss-module__gS2LcG__pdp-slider-main",
  "pdp-wrapper": "ScrollGallery-module-scss-module__gS2LcG__pdp-wrapper",
  "scroll-image-container": "ScrollGallery-module-scss-module__gS2LcG__scroll-image-container",
});
